<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="header-bg">
      <div class="content-nav-bar">
        <van-nav-bar title="结果预览">
          <template #left>
            <van-icon name="arrow-left" size="18" @click="goBack" />
          </template>
        </van-nav-bar>
      </div>
      <div class="content" :style="`height:calc(100vh - ${contentNavBar}px)`">

        <div class="yz-list" >
            <FactorArgumentsModal></FactorArgumentsModal>
        </div>


        <!-- <div class="yz-list" ref="yzList">
          <h2 class="h2">因子组合池(共{{ checkedYzList.length }}只因子)</h2>

          <ul class="yz-ul" v-if="checkedYzList.length">
            <li v-for="item in checkedYzList" :key="item.ID">
              <div class="a-left">
                <div style="display: flex">
                  {{ item.FactorName }}
                  <span class="gs" v-if="item.yzType === 4">公式</span>
                  <span class="gs" v-if="item.yzType === 6">自然</span>
                  <span class="gs" v-if="item.yzType === 2">拖拽</span>
                </div>
                <p class="XiFenZhongLei">{{ item.XiFenZhongLei || item.SubClassName }}</p>
              </div>

              <div class="a-right">
                <div
                  v-if="item.yzType == 0"
                  style="display: flex; justify-content: space-between; width: 70%"
                >
                  <p :class="[judgeColor(item.RiZhangFu)]">
                    {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                  </p>
                  <p class="zhi">{{ item.XinHaoShuLiang || 0 }}只</p>
                </div>

                <div v-else></div>

                <img src="@/assets/image/sc.png" alt="" @click="delYz(item)" />
              </div>
            </li>
          </ul>

          <van-empty
            description="请添加因子"
            :image="require('@/assets/image/notData.png')"
            v-else
          />
        </div> -->

        <div class="condition" :style="!list.length ? 'height:100%' : ''">
          <div :style="`height:calc(100vh - ${contentNavBar + yzList + 97}px)`">
            <van-list
              v-if="list.length"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="getDayStock"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
            >
              <div class="condition_top">
                <h2 class="condition_h2">今日因子组合池信号：{{ resultNum }}只</h2>

                <ul class="li_title">
                  <li>
                    {{ $route.query.yzType == 'ETF' ? 'ETF名称' : '股票名称' }}
                  </li>
                  <li class="order" @click="handleClickOrder('ZuiXinJia')">
                    最新
                    <img
                      src="@/assets/image/screen.png"
                      alt=""
                      class=""
                      v-if="ZuiXinJiaOrder === 0"
                    />
                    <img
                      src="@/assets/image/screen_up.png"
                      alt=""
                      class=""
                      v-if="ZuiXinJiaOrder === 2"
                    />
                    <img
                      src="@/assets/image/screen_down.png"
                      alt=""
                      class=""
                      v-if="ZuiXinJiaOrder === 1"
                    />
                  </li>
                  <li class="order" @click="handleClickOrder('ZhangFu')">
                    涨幅
                    <img
                      src="@/assets/image/screen.png"
                      alt=""
                      class=""
                      v-if="ZhangFuOrder === 0"
                    />
                    <img
                      src="@/assets/image/screen_up.png"
                      alt=""
                      class=""
                      v-if="ZhangFuOrder === 2"
                    />
                    <img
                      src="@/assets/image/screen_down.png"
                      alt=""
                      class=""
                      v-if="ZhangFuOrder === 1"
                    />
                  </li>
                  <li class="order" @click="handleClickOrder('ZhangDie')">
                    涨跌
                    <img
                      src="@/assets/image/screen.png"
                      alt=""
                      class=""
                      v-if="ZhangDieOrder === 0"
                    />
                    <img
                      src="@/assets/image/screen_up.png"
                      alt=""
                      class=""
                      v-if="ZhangDieOrder === 2"
                    />
                    <img
                      src="@/assets/image/screen_down.png"
                      alt=""
                      class=""
                      v-if="ZhangDieOrder === 1"
                    />
                  </li>
                  <li>操作</li>
                </ul>
              </div>
              <ul
                class="li_List"
                v-for="(item, index) in list"
                :key="index"
                @click.stop="gogufs(item.Obj)"
              >
                <li>
                  <p class="ZhongWenJianCheng">{{ item.ZhongWenJianCheng }}</p>
                  <p class="JiaoYiDaiMa">{{ item.JiaoYiDaiMa }}</p>
                </li>
                <li>{{ toFixedNum(item.ZuiXinJia, 2, '') }}</li>
                <li :class="[judgeColor(item.ZhangFu)]">
                  {{ toFixedNum(item.ZhangFu, 2, '%') }}
                </li>
                <li>
                  {{ toFixedNum(item.ZhangDie, 2, '%') }}
                </li>
                <li>
                  <button
                    class="del_btn"
                    v-if="MyZxStock.includes(item.Obj) || addStockList.includes(item.Obj)"
                  >
                    已加入
                  </button>
                  <button class="add_btn" v-else @click.stop="handleClickAddBtn(item.Obj, index)">
                    加自选
                  </button>
                </li>
              </ul>
            </van-list>

            <div v-else>
              <div class="condition_top" style="padding: 10px 16px">
                <h2 class="condition_h2">今日因子组合池信号： 0只</h2>

                <ul class="li_title">
                  <li>股票名称</li>
                  <li class="order">最新</li>
                  <li class="order">涨幅</li>
                  <li class="order">涨跌</li>
                  <li>操作</li>
                </ul>
              </div>
              <van-empty
                :description="loading ? '数据加载中...' : '当日股池数据为空'"
                :image="require('@/assets/image/notData.png')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="handleClickSave" v-if="checkedYzList.length">
      <button @click="showDtzhPopup" v-if="$route.query.dtzhCheckedYzList">
        更新动态组合<van-loading type="spinner" color="#fff" size="12" v-if="isShowBtnLoading" />
      </button>

      <button @click="showDtzhPopup" v-else>
        保存动态组合<van-loading type="spinner" color="#fff" size="12" v-if="isShowBtnLoading" />
      </button>
    </div>

    <van-popup v-model="showPopup" :close-on-click-overlay="false">
      <div class="popupContent">
        <h1 class="title" v-if="$route.query.dtzhCheckedYzList">更新动态组合</h1>
        <h1 class="title" v-else>保存动态组合</h1>

        <p class="name">动态组合名称</p>

        <van-field v-model="dtzuValue" placeholder="请输入动态组合名称" />

        <div class="btn">
          <van-button type="default" @click="showPopup = false">取消</van-button>
          <van-button
            v-if="$route.query.dtzhCheckedYzList"
            type="info"
            :disabled="dtzuValue === '' || dtzhSaveLoading"
            @click="handleClickUpDtzh"
            :loading="dtzhSaveLoading"
            loading-text="更新中..."
            >更新动态组合</van-button
          >

          <van-button
            v-else
            type="info"
            :disabled="dtzuValue === '' || dtzhSaveLoading"
            @click="handleClickSaveDtzh"
            :loading="dtzhSaveLoading"
            loading-text="保存中..."
            >保存动态组合</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import { insertStockByGroup, getMyZxStockInfo } from '@/api/index.js';
import {
  judgeColor,
  toFixedNum,
  removeValueFromArray,
  fangDouFun,
  strToHexCharCode,
  factorCombinationToCode,
  getFactorNames
} from '@/utils/format';
import { getDayStockPool, getMyDynamicCount, addDynamic, updateMyDynamic } from '@/api/create.js';

import { Base64 } from 'js-base64';

export default {
  name: 'Dtzh-preview',
  mixins: [mixin],
  data() {
    return {
      page: 1,
      resultNum: 0,
      list: [],
      MyZxStock: [],
      addStockList: [],
      loading: false,
      finished: false,
      error: false,
      yzList: 0,
      field: 'ZhangFu',
      ZuiXinJiaOrder: 0,
      ZhangFuOrder: 1,
      ZhangDieOrder: 0,
      desc: true,
      showPopup: false,
      dtzuValue: '',
      isShowBtnLoading: false,
      hexyzIds: '',
      yzIds: [],
      yzFactorName: [],
      dtzhSaveLoading: false
    };
  },
  //计算属性
  computed: {
    checkedYzList: function () {
      return this.$store.state.checkedYzList; // 获取全局状态
    },
    Obj: function () {
      return this.$store.state.Obj; // 获取全局状态
    },
    contentNavBar: function () {
      return this.$store.state.contentNavBar; // 获取全局状态
    },
    publicHcID: function () {
      return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
    },
    type: function () {
      return this.$store.state.type; // 获取vuex的id 要是存在id走编辑逻辑
    },
    groupYzList() {
        return this.$store.state.groupYzList;
    },
    checkedYzType(){
        return this.$store.state.checkedYzType;
    }
  },

  watch: {
    // async checkedYzList(item) {
    //   this.yzIds = [];
    //   item.forEach((i) => {
    //     if (i.yzType != 0) {
    //       if (i.yzType == 4) {
    //         this.yzIds.push('F' + strToHexCharCode(i.Info) + '&');
    //       } else {
    //         this.yzIds.push(i.Info + '&');
    //       }
    //     } else {
    //       this.yzIds.push(i.ID + '&');
    //     }

    //     if (i.FactorName) {
    //       this.yzFactorName.push(i.FactorName);
    //     }
    //   });

    //   this.hexyzIds = ':' + strToHexCharCode(':&' + this.yzIds.join(''));

    //   this.page = 1;
    //   this.resultNum = 0;
    //   this.list = [];
    //   await this.getMyOptional();
    //   await this.getDayStock();
    //   this.yzList = this.$refs.yzList.offsetHeight;
    // }
  },
  components: {},
  filters: {},
  created() {},
  async mounted() {
    // if (window.DzhAppJs) {
    //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
    // }

    // this.yzIds = [];
    // this.checkedYzList.forEach((i) => {
    //   if (i.yzType != 0) {
    //     if (i.yzType == 4) {
    //       this.yzIds.push('F' + strToHexCharCode(i.Info) + '&');
    //     } else {
    //       this.yzIds.push(i.Info + '&');
    //     }
    //   } else {
    //     this.yzIds.push(i.ID + '&');
    //   }

    //   this.hexyzIds = ':' + strToHexCharCode(':&' + this.yzIds.join(''));

    //   if (i.FactorName) {
    //     this.yzFactorName.push(i.FactorName);
    //   }
    // });

    // 解析 groupYzList（因子交并集分组数据）
    if (this.$route.query.groupYzList) {
      let groupList = JSON.parse(this.decodeUrlParameter(this.$route.query.groupYzList));
      console.log('dtzh-preview groupYzList', groupList);
      this.$store.commit('setGroupYzList', groupList);
    }

    // 解析 checkedYzType（交并集类型：jj=交集，bj=并集）
    if (this.$route.query.checkedYzType) {
      console.log('dtzh-preview checkedYzType', this.$route.query.checkedYzType);
      this.$store.commit('setCheckedYzType', this.$route.query.checkedYzType);
    }

    var _this = this;
    // 组合因子交并集
    var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);
    console.log('hexYzObj',hexYzObj);
    this.hexyzIds = hexYzObj.hexyzIds


    await this.getMyOptional();
    await this.getDayStock();
    // this.yzList = this.$refs.yzList.offsetHeight;
  },
  methods: {
    judgeColor,
    toFixedNum,

    //将URL参数中的 * 替换为 +，- 替换为 /，. 替换为 =，然后进行Base64解码
    decodeUrlParameter: function (encodedUrl) {
      var replacedString = encodedUrl.replace(/\*/g, '+').replace(/-/g, '/').replace(/\./g, '=');

      var decodedString = Base64.decode(replacedString);

      return decodedString;
    },

    //将数据进行Base64编码，+ 替换为 *，/ 替换为 -，= 替换为 .
    encodeUrlParameter: function (data) {
      var jsonString = JSON.stringify(data);
      var encodedString = Base64.encode(jsonString);
      var replacedString = encodedString
        .replace(/\+/g, '*')
        .replace(/\//g, '-')
        .replace(/=/g, '.');
      return replacedString;
    },

    //删除选中的因子 -
    delYz: function (item) {
      removeValueFromArray(this.checkedYzList, item.ID);
      this.$store.commit('setCheckedYzList', this.checkedYzList);
    },

    //点击排序
    handleClickOrder: function (field = 'ZhangFu') {
      this.page = 1;
      if (field === 'ZuiXinJia') {
        this.ZhangDieOrder = 0;

        this.ZuiXinJiaOrder = (this.ZuiXinJiaOrder + 1) % 3;

        if (this.ZuiXinJiaOrder === 0) {
          this.desc = true;
          this.field = 'ZhangFu';
          this.ZhangFuOrder = 1;
        } else if (this.ZuiXinJiaOrder === 2) {
          this.field = 'ZuiXinJia';
          this.desc = false;
          this.ZhangFuOrder = 0;
        } else if (this.ZuiXinJiaOrder === 1) {
          this.field = 'ZuiXinJia';
          this.desc = true;
          this.ZhangFuOrder = 0;
        }
      } else if (field === 'ZhangFu') {
        this.ZuiXinJiaOrder = 0;
        this.ZhangDieOrder = 0;

        this.ZhangFuOrder = (this.ZhangFuOrder + 1) % 3;

        if (this.ZhangFuOrder === 0) {
          this.desc = true;
        } else if (this.ZhangFuOrder === 2) {
          this.desc = false;
        } else if (this.ZhangFuOrder === 1) {
          this.desc = true;
        }

        this.field = 'ZhangFu';
      } else if (field === 'ZhangDie') {
        this.ZuiXinJiaOrder = 0;
        this.ZhangFuOrder = 0;

        this.ZhangDieOrder = (this.ZhangDieOrder + 1) % 3;

        if (this.ZhangDieOrder === 0) {
          this.desc = true;
          this.field = 'ZhangFu';
          this.ZhangFuOrder = 1;
        } else if (this.ZhangDieOrder === 2) {
          this.desc = false;
          this.field = 'ZhangDie';
          this.ZhangFuOrder = 0;
        } else if (this.ZhangDieOrder === 1) {
          this.field = 'ZhangDie';
          this.desc = true;
          this.ZhangFuOrder = 0;
        }
      }

      this.loading = true;
      this.list = [];

      this.getDayStockPoolFun(this.hexyzIds);
    },

    getDayStock: function (field = 'ZhangFu') {
      this.loading = true;
      this.field = field;
      this.getDayStockPoolFun(this.hexyzIds);
    },

    //当日股池
    getDayStockPoolFun: function (hexyzIds) {
      this.$toast.loading({
        message: '加载中...',
        overlay: true,
        duration: 0
      });

      if (!hexyzIds) {
        this.loading = false;
        return false;
      }

      var params = {
        factorIDs: hexyzIds, //string 因子id组，逗号分隔,如：单个因子时factorIDs=Id1，多因子 factorIDs=Id1,Id2,Id3,Id4
        start: this.page,
        count: 50,
        desc: this.desc, //排序方式, 可选项包括:false(升序),true(降序)
        field: this.field //排序字段,*表示必填,可选项见表后说明,排序字段只能从field可选项中任选其一
      };
      getDayStockPool(params)
        .then((res) => {
          console.log('getDayStockPool response:', res);
          console.log('res.err type:', typeof res.err, 'value:', res.err);
          console.log('res.err === 200:', res.err === 200);

          this.finished = true;
          this.$toast.clear();
          this.finished = true;
          this.loading = false;
          this.error = false;
          if (res.err === 200) {
            console.log('res.data:', res.data);
            console.log('res.data.list:', res.data?.list);
            this.resultNum = res.data.ObjCount || 0;
            this.list.push(...res.data.list);

            if (res.data.list.length < 50) {
              this.finished = true;
            } else {
              this.finished = false;
            }

            this.page += 50;
          }
        })
        .catch((err) => {
          this.list = [];
          this.finished = true;
          this.error = true;
          this.loading = false;
          this.$toast(err);
        });
    },

    // 获取我的自选股
    getMyOptional: function () {
      getMyZxStockInfo({}).then((res) => {
        if (res.err === 200) {
          this.MyZxStock = res.data.Stocks || [];
        }
      });
    },
    handleClickAddBtn: fangDouFun(function (...args) {
      this.addStock(...args);
    }, 300),
    // 加自选
    addStock: function (StockCode) {
      let obj = {
        stocks: StockCode
      };
      insertStockByGroup(obj).then((res) => {
        if (res.err === 200) {
          this.addStockList.push(StockCode);
          this.$toast('加入成功');
        } else {
          this.$toast('加入失败');
        }
      });
    },

    linkGo: function () {
      var _this = this;

      _this.takeShow = false;

      if (!_this.checkedYzList.length) {
        _this.$toast('至少添加一个因子');

        return false;
      }

      _this.loading = true;
    },

    goBack: function () {
      let query;

      if (this.$route.query.dtzhCheckedYzList) {
        query = {
          source: 'dtzh',
          type: 'add',
          token: this.$route.query.token || '',
          mySource: this.$route.query.mySource,
          themeStyleVs: this.$route.query.themeStyleVs || 0,
          version: this.$route.query.version || '',
          dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
          groupYzList: this.groupYzList.length ? this.encodeUrlParameter(this.groupYzList) : '',
          checkedYzType: this.checkedYzType || '',
          id: this.$route.query.id || '',
          name: this.$route.query.name || '',
          yzType: this.$route.query.yzType || ''
        };
      } else {
        query = {
          source: 'dtzh',
          type: 'add',
          token: this.$route.query.token || '',
          mySource: this.$route.query.mySource,
          themeStyleVs: this.$route.query.themeStyleVs || 0,
          version: this.$route.query.version || '',
          yzType: this.$route.query.yzType || ''
        };
      }

      this.$router.push({
        path: '/checkedYz',
        name: 'CheckedYz',
        query: query
      });
    },

    //获取动态组合名称的数量
    getMyDynamicCountFun: function () {
      getMyDynamicCount()
        .then((res) => {
          this.isShowBtnLoading = false;
          this.dtzuValue =
            this.$route.query.yzType == 'ETF'
              ? 'ETF动态组合' + (res.data.count + 1)
              : '动态组合' + (res.data.count + 1);
          this.showPopup = true;
        })
        .catch((err) => {
          this.isShowBtnLoading = false;
          this.$toast(err);
        });
    },

    //点击动态组合按钮显示弹框
    showDtzhPopup: function () {
      if (this.$route.query.dtzhCheckedYzList) {
        this.dtzuValue = this.decodeUrlParameter(this.$route.query.name);
        this.showPopup = true;
      } else {
        this.isShowBtnLoading = true;
        this.getMyDynamicCountFun();
      }
    },

    //保存动态组合
    handleClickSaveDtzh: function () {
        var _this = this;
        this.dtzhSaveLoading = true;

        //   var idArray = this.checkedYzList.map((obj) => {
        //     if (obj.yzType != 0) {
        //       //自选和模版的取info字段 其他的直接取id
        //       return obj.Info;
        //     } else {
        //       return obj.ID;
        //     }
        //   });

        var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);


        var collection_condition = {
            composeType: _this.checkedYzType,
            yzList: _this.checkedYzList,
            children: _this.groupYzList
        };

        this.yzFactorName = getFactorNames(
            _this.checkedYzList.concat(_this.groupYzList)
        );



      addDynamic({
        fd_name: this.dtzuValue,
        f_name_arr: this.yzFactorName.toString(),
        f_id_arr: hexYzObj.hexyzIds,
        collection_condition: JSON.stringify(collection_condition),
        collection_type: _this.checkedYzType == "jj" ? 1 : 2, //交并集状态: 0没有交并集 1交集组合 2 并集组合
        collection_info: hexYzObj.idArrayToStr,
        type_info: this.$route.query.yzType == 'ETF' ? 2 : 1 //1- A 股 2-ETF
      })
        .then((res) => {
          this.dtzhSaveLoading = false;
          this.isShowBtnLoading = false;
          this.$toast(res.msg);

          if (res.err === 200) {
            var url = `dzh_browser_url&goto=0&screen=468&factorid=${this.hexyzIds}&factorname=${this.dtzuValue}&fdId=${res.data.fd_id}`;

            window.location.href = `dzh_browser_url&goto=0&screen=263&nextUrl=${Base64.encode(
              url
            )}`;

            //因子-动态选股列表页 factorid 因子id，factorname 因子名称
          }
        })
        .catch((err) => {
          this.dtzhSaveLoading = false;
          this.isShowBtnLoading = false;
          this.$toast(err);
        });
    },

    //更新动态组合
    handleClickUpDtzh: function () {
        var _this = this;
      this.dtzhSaveLoading = true;

    //   var idArray = this.checkedYzList.map((obj) => {
    //     if (obj.yzType != 0) {
    //       //自选和模版的取info字段 其他的直接取id
    //       return obj.Info;
    //     } else {
    //       return obj.ID;
    //     }
    //   });
      var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);

      var collection_condition = {
            composeType: _this.checkedYzType,
            yzList: _this.checkedYzList,
            children: _this.groupYzList
        };

      this.yzFactorName = getFactorNames(
            _this.checkedYzList.concat(_this.groupYzList)
        );

      updateMyDynamic({
        fd_id: this.$route.query.id,
        fd_name: this.dtzuValue,
        f_name_arr: this.yzFactorName.toString(),
        f_id_arr: hexYzObj.hexyzIds,
        collection_condition: JSON.stringify(collection_condition),
        collection_type: _this.checkedYzType == "jj" ? 1 : 2, //交并集状态: 0没有交并集 1交集组合 2 并集组合,
        collection_info: hexYzObj.idArrayToStr
      })
        .then((res) => {
          this.dtzhSaveLoading = false;
          this.isShowBtnLoading = false;
          this.$toast(res.msg);

          if (res.err === 200) {
            var url = `dzh_browser_url&goto=0&screen=468&factorid=${this.hexyzIds}&factorname=${this.dtzuValue}&fdId=${this.$route.query.id}`;

            window.location.href = `dzh_browser_url&goto=0&screen=263&nextUrl=${Base64.encode(
              url
            )}`;

            //因子-动态选股列表页 factorid 因子id，factorname 因子名称
          }
        })
        .catch((err) => {
          this.dtzhSaveLoading = false;
          this.isShowBtnLoading = false;
          this.$toast(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep {
  .van-list__finished-text,
  .van-loading__text {
    color: #323233;
    font-size: 12px;
  }
}
.h2 {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}
.index-info {
  position: relative;
  .content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .yz-list {
      padding: 16px;
      .yz-ul {
        border-radius: 8px;
        padding: 4px 8px;
        background: rgba(247, 247, 252, 0.64);
        margin-top: 8px;
        li {
          margin: 6px 0;
          border: 1px solid #e7e7e7;
          padding: 3.5px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          .a-left {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.9);
            padding-left: 9.5px;
            .gs {
              border-radius: 20px;
              border: 1.5px solid #2999df;
              padding: 0 8px;
              color: #2999df;
              font-size: 10px;
              flex-shrink: 0;
              height: 16px;
              margin-top: 2px;
              margin-left: 4px;
              display: flex;
              align-items: center;
            }
            .XiFenZhongLei {
              font-size: 10px;
              color: #999;
            }
          }
          .a-right {
            border-radius: 4px;
            padding: 8px 12px;
            background: rgba(0, 0, 0, 0.02);
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 50%;
            font-size: 12px;
            color: #555;
            img {
              width: 17px;
              height: 16px;
              flex-shrink: 0;
            }
          }
        }
      }
    }
    .condition {
      background: #fff;
      border-radius: 8px 8px 0 0;
      padding: 12px 0;
      ::v-deep {
        .van-list {
          padding: 0 16px 80px;
          background: #fff;
        }
      }
      .condition_top {
        position: sticky;
        top: -1px;
        left: 0;
        background: #fff;
        width: 100%;
        padding: 10px 0;
        .condition_h2 {
          color: #555;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
        }
        .li_title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 14px;
          .order {
            display: flex;
            align-items: center;
            justify-content: right;
            img {
              width: 10px;
              height: 12px;
            }
          }

          li {
            width: 20%;
            color: #999;
            text-align: right;
            font-size: 12px;
            &:first-child {
              text-align: left;
            }
          }
        }
      }
      .li_List {
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
          width: 20%;
          color: #373a4d;
          text-align: right;
          font-size: 14px;
          margin: 10px 0;
          &:first-child {
            text-align: left;
          }
          .ZhongWenJianCheng {
            color: #373a4d;
            font-size: 14px;
            font-weight: 600;
          }
          .JiaoYiDaiMa {
            color: #999;
            font-size: 12px;
          }
          .add_btn,
          .del_btn {
            border-radius: 2px;
            padding: 0px 5px;
            font-size: 11px;
            font-weight: 400;
          }
          .add_btn {
            background: rgba(40, 109, 247, 0.06);
            color: #286df7;
          }

          .del_btn {
            background: rgba(153, 153, 153, 0.06);
            color: #999;
          }
        }
      }
    }
  }
  .handleClickSave {
    width: 100%;
    position: fixed;
    bottom: 34px;
    padding: 0 34px;
    text-align: center;
    button {
      width: 100%;
      border-radius: 20px;
      background: #286df7;
      height: 42px;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      text-align: center;
    }
  }
  ::v-deep {
    .van-popup {
      width: 285px;
      padding: 16px;
      border-radius: 10px;
      background: #fff;
    }
  }
  .popupContent {
    .title {
      color: #222;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 20px;
    }
    .name {
      color: #555;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 4px;
    }
    ::v-deep {
      .van-cell {
        border-radius: 4px;
        border: 0.5px solid #e5e5e5;
        height: 38px;
        line-height: 38px;
        padding: 0 9px;
        &::after {
          border: none;
        }
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      ::v-deep {
        .van-button {
          border-radius: 6px;
          height: 36px;
          width: 50%;
          border: none !important;
          font-size: 14px;
        }
        .van-button--default {
          background: #f0f0f0;
          margin-right: 12px;
          color: #222;
        }

        .van-button--disabled {
          color: #fff !important;
          background: #93b6fb !important;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  ::v-deep {
    .van-list__finished-text,
    .van-loading__text {
      color: #6b7687 !important;
      font-size: 12px;
    }
  }
  .content {
    .yz-list {
      .h2 {
        color: #e4e9fe;
      }
    }
    .yz-ul {
      background: rgba(255, 255, 255, 0.15) !important;
      li {
        background: rgb(30, 31, 45) !important;
        border: 1px solid rgb(30, 31, 45) !important;
        .a-left,
        .a-right .zhi {
          color: #e4e9fe !important;
        }
        .a-right {
          p {
            color: #aab9d1;
          }
        }
      }
    }
    .condition {
      background: #191a24;
      .condition_top {
        background: #191a24;
        .condition_h2 {
          color: #aab9d1;
        }
        .li_title {
          li {
            color: #6b7687;
          }
        }
      }
      .li_List {
        li {
          color: #e4e9fe;
          .ZhongWenJianCheng {
            color: #e4e9fe;
          }
          .JiaoYiDaiMa {
            color: #6b7687;
          }
        }
      }
      ::v-deep {
        .van-list {
          padding: 0 16px 80px;
          background: #191a24;
        }
      }
      .h2 {
        color: #e4e9fe;
      }

      .van-popup {
        background: #1e1f2d;
      }
    }
  }

  .bottom-btn {
    background: #2e3548 !important;
  }
  .setup-ing {
    background: #2e3548 !important;
    border: none;
  }

  ::v-deep {
    .van-popup {
      background: #181a23;
    }
  }
  .popupContent {
    .title {
      color: #e4e9fe;
    }
    .name {
      color: #aab9d1;
    }
    ::v-deep {
      .van-cell {
        border: 0.5px solid #2f3139;
        background: none;
      }
      .van-field__control {
        color: #e4e9fe;
      }
    }
    .btn {
      ::v-deep {
        .van-button--default {
          background: #262830;
          color: #e4e9fe;
        }

        .van-button--disabled {
          color: #8b8c91 !important;
          background: #294f90 !important;
        }
      }
    }
  }
}
</style>
